export const GET_VIDEOGAMES = 'GET_VIDEOGAMES'
export const GET_DETAILS_VIDEOGAMES = 'GET_DETAILS_VIDEOGAMES'
export const GET_VIDEOGAMES_NAME = 'GET_VIDEOGAMES_NAME'
export const CLEAR_PAGE ='CLEAR_PAGE'
export const FILTER_GENRES ='FILTER_GENRES'
export const ALL_GENRES ='ALL_GENRES'
export const FILTER_CREATED = 'FILTER_CREATED' 
export const ORDER_NAME = 'ORDER_NAME'
export const ORDER_RATING = 'ORDER_RATING'
export const CREATE_VIDEOGAME = 'CREATE_VIDEOGAME'
export const DELETE ='DELETE'
export const UPDATE_VG ='UPDATE_VG'